import { connect } from "react-redux";
import { closeBrokerInviteModal } from "actions/broker_invite_modal";
import { inviteUser } from "actions/user";
import { withFormik } from "formik";
import validationSchema from "forms/BrokerInviteForm/validationSchema";
import { isAssetDetail } from "selectors/location";
import { selectedPortfolioSelector } from "selectors/portfolio";

import BrokerInviteModal from "./BrokerInviteModal";

const form = withFormik({
  displayName: "broker",
  enableReinitialize: false,
  mapPropsToValues: ({ asset, isAssetDetailPage, selectedPortfolio }) => ({
    assets: isAssetDetailPage ? [asset] : [],
    portfolio: isAssetDetailPage ? asset.portfolio : selectedPortfolio,
  }),
  handleSubmit: (values, { props: { onInviteUser }, setSubmitting }) =>
    onInviteUser(values).finally(() => setSubmitting(false)),
  validationSchema: () => validationSchema,
})(BrokerInviteModal);

const mapStateToProps = (state) => ({
  asset: state.asset,
  isAssetDetailPage: isAssetDetail(state),
  isSubmitting: state.loading.user,
  selectedPortfolio: selectedPortfolioSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  onInviteUser: (data) =>
    dispatch(inviteUser({ ...data.user, company: data.company }, data.assets)),
  onClose: () => dispatch(closeBrokerInviteModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(form);
